import React from "react"
import Link from "./link"

interface IFancyImageProps {
  src: string
  alt: string
  uri?: string
}

export default function FancyImage({
  src,
  uri,
  alt,
}: IFancyImageProps): JSX.Element {
  return (
    <div className="aspect-square group relative overflow-hidden rounded w-full shrink-0">
      {uri ? (
        <Link to={uri}>
          <img
            alt="Georgian College Accelerator Icon"
            className="aspect-square object-cover w-full object-top group-hover:scale-110 transition-transform ease-in-out duration-300"
            src={
              src ||
              `https://georgiancollege.ca/i/logos/colour/accelerator-icon.png`
            }
          />
        </Link>
      ) : (
        <img
          className="aspect-square object-cover w-full object-top group-hover:scale-110 transition-transform ease-in-out duration-300"
          src={
            src ||
            `https://georgiancollege.ca/i/logos/colour/accelerator-icon.png`
          }
        />
      )}
    </div>
  )
}
